class FormSuccessModal {
    constructor() {
        this.modal = document.querySelector('.modal-form-success');
        this.closeButton = this.modal?.querySelector('.btnCloseFormSuccess');

        if (!this.modal || !this.closeButton) return;

        this.bindEvents();

        const searchParams = new URLSearchParams(window.location.search);
        const hasSuccessInPortuguese = searchParams.get('sucesso') === 'sim';
        const hasSuccessInEnglish = searchParams.get('success') === 'yes';

        if (hasSuccessInPortuguese || hasSuccessInEnglish) {
            this.open();
        }
    }

    open() {
        this.modal.classList.add('active');
        this.modal.removeAttribute('aria-hidden');
        this.modal.removeAttribute('inert');
        document.body.classList.add('overflow-hidden');
        window.setTimeout(() => this.closeButton.focus(), 120);
    }

    close() {
        this.modal.classList.remove('active');
        this.modal.setAttribute('aria-hidden', 'true');
        this.modal.setAttribute('inert', '');
        document.body.classList.remove('overflow-hidden');
    }

    bindEvents() {
        this.closeButton.addEventListener('click', () => this.close());

        this.modal.addEventListener('click', event => {
            if (event.target === this.modal) this.close();
        });

        document.addEventListener('keydown', event => {
            if (event.key === 'Escape' && this.modal.classList.contains('active')) {
                this.close();
            }
        });
    }
}

new FormSuccessModal();
